import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { Link } from 'react-router-dom';
import { theme } from 'styles/theme';

export const Tab = ({
	to,
	children,
	active,
	horizontal,
}: {
	to: string;
	children: ReactNode;
	active?: boolean;
	horizontal?: boolean;
}) => {
	return (
		<Link
			to={to}
			css={css`
				display: flex;
				padding: 12px 0;
				color: ${theme.color.text['400']};

				gap: 8px;

				align-items: center;

				${!horizontal &&
				css`
					border-radius: 12px;
				`}

				&:hover {
					text-decoration: none;
					color: ${theme.color.primary['400']};
				}

				${active &&
				css`
					color: ${theme.color.primary['400']};
					font-weight: bold;

					${!horizontal &&
					css`
						background: ${theme.color.primary['50']};
					`}

					${horizontal &&
					css`
						box-shadow: inset 0 -2px 0 0 ${theme.color.primary['400']};
					`}
				`}
			`}
		>
			{children}
		</Link>
	);
};
